import { render, staticRenderFns } from "./RoleEditor.vue?vue&type=template&id=79f6e7d0&"
import script from "./RoleEditor.vue?vue&type=script&lang=js&"
export * from "./RoleEditor.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditor.vue?vue&type=style&index=0&id=79f6e7d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports